import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";

import { Button, Result, Spin } from "antd";
import {
  HistoryOutlined,
  PhoneOutlined,
  MailOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

import { getOrderData, getOrderDataTransaction } from "../../api";
import { formatPrice } from "../../utils/common";
import * as queryString from "query-string";

interface Props {
  handleChangeView: any;
  cancelEmbed: any;
}

const WalletPaymentConfirmation: React.FC<Props> = ({
  handleChangeView,
  cancelEmbed,
}) => {
  const { pathname, search } = useLocation();
  const history = useHistory();
  const [openPopup, setOpenPopup] = useState<boolean>(true);
  const [isEmbed, setIsEmbed] = useState<boolean>(false);
  const [paymentLink, setPaymentLink] = useState<string>("");
  const [orderLoading, setOrderLoading] = useState<boolean>(false);
  const [orderData, setOrderData] = useState<any>(null);
  const [paymentData, setPaymentData] = useState<any>({
    status: "checking",
    orderId: null,
  });

  const [countdown, setCountdown] = useState<number>(5);
  const { t } = useTranslation(["common", "notification", "wallet"]);
  useEffect(() => {
    const timer =
      countdown > 0 &&
      setInterval(() => {
        setCountdown((prev: any) => prev - 1);
      }, 1000);

    if (countdown === 0) {
      return clearInterval(timer as NodeJS.Timeout);
    }
    return () => {
      clearInterval(timer as NodeJS.Timeout);
    };
  }, [countdown]);

  useEffect(() => {
    const parseQuery = queryString.parse(search);

    if (parseQuery && parseQuery.paymentStatus) {
      setPaymentData((prev: any) => ({
        ...prev,
        status: parseQuery.paymentStatus,
      }));
    }

    if (parseQuery && parseQuery.orderId) {
      setPaymentData((prev: any) => ({
        ...prev,
        orderId: parseQuery.orderId,
      }));
    }

    if (parseQuery && parseQuery.embed) {
      setIsEmbed(parseQuery.embed === "true");
    }
  }, [pathname, search]);

  useEffect(() => {
    fetchOrderData();
  }, []);

  const checkOrderData = async () => {
    const parseQuery = queryString.parse(search);
    let count = 0;
    setOrderLoading(true);

    const orderDataPending = await getOrderData(parseQuery.orderId);
    const orderTransactionData =
      orderDataPending.data.order_transaction_data[0];

    var timer = await setInterval(async () => {
      const orderTransaction = await getOrderDataTransaction(
        orderTransactionData.transaction_id
      );
      const orderDataRes = await getOrderData(parseQuery.orderId);

      count += 1;

      // history.push to payment url
      if (orderDataRes) {
        if (orderDataRes.data.order_status === "order_success") {
          setPaymentData((prev: any) => ({
            ...prev,
            status: "success",
          }));

          setCountdown(5);
          setOrderLoading(false);
          clearInterval(timer);
          return;
        } else if (
          orderDataRes.data.order_status !== "order_success" &&
          orderDataRes.data.order_status !== "order_pending_payment"
        ) {
          setPaymentData((prev: any) => ({
            ...prev,
            status: "error",
          }));

          setOrderLoading(false);
          clearInterval(timer);
          return;
        }
      }

      if (count > 3) {
        setOrderLoading(false);
        clearInterval(timer);
        return;
      }
    }, 1000);
  };
  const [gatewayWindow, setGatewayWindow] = useState<any>(null);

  function openPaymentLink(url: string) {
    setOpenPopup(true);
    // const child = window.open(
    //   url,
    //   "paymentPopup",
    //   "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=600,height=800"
    // );
    // const child = window.location.href = url;
    window.location.href = url;
    console.log('url', url);
    // setGatewayWindow(child);

    // var timer = setInterval(() => {
    //   if (child && child.closed) {
    //     console.log("Child window closed");
    //     setOpenPopup(false);
    //     clearInterval(timer);

    //     checkOrderData();
    //   }
    // }, 500);
  }

  const fetchOrderData = async () => {
    const parseQuery = queryString.parse(search);
    setOrderLoading(true);

    const orderDataRes = await getOrderData(parseQuery.orderId);
    setOrderData(orderDataRes.data);

    // history.push to payment url
    if (orderDataRes) {
      if (orderDataRes.data.order_status === "order_pending_payment") {
        const url = orderDataRes.data.payment_links[0].payment_link;

        setPaymentLink(url);

        openPaymentLink(url);
      } else if (orderDataRes.data.order_status === "order_success") {
        setPaymentData((prev: any) => ({
          ...prev,
          status: "success",
        }));
      } else {
        setPaymentData((prev: any) => ({
          ...prev,
          status: "error",
        }));
      }
    }

    setOrderLoading(false);
  };

  const processCancelEmebed = () => {
    if (gatewayWindow) {
      gatewayWindow.close();
    }

    cancelEmbed();
  };
  // const test = () => {
  //   console.log('send')
  //   window.opener.postMessage('Message to the parent', '*')
  // }

  // Success
  if (paymentData.status === "success") {
    return (
      <Result
        status="success"
        title="Thanh toán thành công!"
        subTitle={
          <>
            <span>{`Quý khách đã nạp thành công ${formatPrice(
              orderData.total_price
            )}đ vào tài khoản. Mã giao dịch: `}</span>
            <span>
              <b>{orderData.order_code}</b>
            </span>
          </>
        }
        extra={[
          !isEmbed ? (
            <Button
              key="back"
              onClick={() => {
                history.push(
                  pathname +
                  "?" +
                  queryString.stringify(
                    { type: "overview" },
                    { skipNull: true, skipEmptyString: true }
                  )
                );
                handleChangeView("overview");
              }}
              disabled={countdown > 0}
            >
              {t("common:Trở lại trang thanh toán")}{" "}
              {countdown > 0 ? `(${countdown})` : ""}
            </Button>
          ) : (
            <Button key="exit" onClick={cancelEmbed}>
              {t("common:Trở lại trang thanh toán")}
            </Button>
          ),
        ]}
        style={{ background: "#ffffff", borderRadius: "3px" }}
      />
    );
  }

  // Error
  if (paymentData.status === "error") {
    return (
      <Result
        status="error"
        title="Thành toán thất bại!"
        subTitle={
          <>
            <span>
              Rất tiếc! Yêu cầu thanh toán của Quý khách trên hệ thống VNTRIP.VN
              chưa thành công.
            </span>
            <br />
            <span>
              Quý khách vui lòng liên hệ với bộ phận chăm sóc khách hàng để được
              hỗ trợ ngay!
            </span>
            <br />
            <br />
            <span style={{ color: "black" }}>
              <PhoneOutlined /> Hotline: 1900 636484
            </span>{" "}
            <span> - </span>{" "}
            <span style={{ color: "black" }}>
              <MailOutlined /> Email: cs@vntrip.vn
            </span>
          </>
        }
        extra={[
          !isEmbed ? (
            <Button
              key="back"
              onClick={() => {
                handleChangeView("overview");
              }}
            >
              {t("common:Trở lại trang thanh toán")}
            </Button>
          ) : (
            <Button key="exit" onClick={cancelEmbed}>
              {t("common:Hủy")}
            </Button>
          ),
        ]}
        style={{ background: "#ffffff", borderRadius: "3px", height: "500px" }}
      />
    );
  }

  // Pending
  return (
    <Spin
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      spinning={orderLoading}
    >
      <Result
        icon={<HistoryOutlined style={{ color: "#ef4343" }} />}
        title={t("common:Đang kiểm tra quá trình thanh toán")}
        // subTitle="Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
        extra={[
          !isEmbed ? (
            <Button
              className="w-full md:w-fit"
              key="back"
              onClick={() => {
                history.push(
                  pathname +
                  "?" +
                  queryString.stringify(
                    { type: "overview" },
                    { skipNull: true, skipEmptyString: true }
                  )
                );
                handleChangeView("overview");
              }}
            >
              {t("common:Trở lại trang thanh toán")}
            </Button>
          ) : (
            <Button
              key="exit"
              onClick={processCancelEmebed}
              className="w-full md:w-fit"
            >
              {t("common:Hủy")}
            </Button>
          ),
          <Button
            type="primary"
            key="continue"
            className="mt-16 md:mt-0 w-full md:w-fit"
            disabled={openPopup}
            onClick={() => {
              openPaymentLink(paymentLink);
            }}
          >
            {t("common:Tiếp tục thanh toán")}
          </Button>,
        ]}
        style={{ background: "#ffffff", borderRadius: "3px", height: "500px" }}
      />
    </Spin>
  );
};

export default WalletPaymentConfirmation;
